module.exports = __webpack_public_path__ + "static/media/ag.886dd7a5.svg";